<template>
  <div class="multiple-file-upload-root" @paste.native="onWrapperPaste">
    <el-upload
      :http-request="uploadHandle"
      :limit="limit"
      action=""
      :show-file-list="false"
      :multiple="true"
      :before-upload="beforeUpload"
      ref="uploader"
    >
      <el-button size="small" type="primary">点击上传</el-button>
      <span slot="tip" class="el-upload__tip"> {{ uploadTip }} </span>
    </el-upload>

    <div class="file-list">
      <div v-for="(file, index) in fileList" :key="index" class="file-item">
        <span>
          <i class="el-icon-document"></i>
          {{ file.name }}
        </span>
        <i
          v-if="file.status === 'success' || !file.status"
          :class="hoveredFile === file ? 'el-icon-delete delete' : 'el-icon-success success'"
          @click="clearByIndex(index)"
          @mouseenter="hoveredFile = file"
          @mouseleave="hoveredFile = null"
        ></i>
        <i v-if="file.status === 'uploading'" class="el-icon-loading uploading"></i>
        <i v-if="file.status === 'error'" class="el-icon-error error"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { Toolkit, OssUtil } from "@/util";
export default {
  components: {},
  props: {
    onUploadSuccess: Function,
    value: Array,
    bucket: {
      type: String,
      default: "yxmgt-private"
    },
    uploadTip: {
      type: String,
      default: "支持单个或多个文件上传，单个文件大小不超过20MB"
    },
    filePath: {
      type: String,
      default: "/driver/contract"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 3
    },
    simpleData: {
      type: Boolean,
      default: false
    },
    beforeUpload: {
      type: Function,
      default: () => true
    },
    /** 是否启用剪贴板文件粘贴上传（Ctrl+V / Cmd+V）。纯文本不受影响 */
    pasteUpload: {
      type: Boolean,
      default: false
    },
    /**
     * 是否在 document 上捕获 paste（弹窗内任意焦点即可粘贴）。为 false 时仅组件内有焦点时生效。
     * 关闭弹窗时请设为 false（例如 :paste-capture="visible"）。多实例同时开启时只有会先抢到监听的那一个生效。
     */
    pasteCapture: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    pasteCaptureActive() {
      this.syncPasteCaptureListener();
    },
    value: {
      handler(val = []) {
        if (val.length > 0) {
          if (val[0] instanceof Object) {
            this.fileList = [...val];
          } else {
            this.fileList = val.map((t) => ({
              name: Toolkit.getFileNameFromUrl(t),
              url: t,
              status: "success",
              uid: t
            }));
          }
        } else {
          this.fileList = [];
        }
      },
      immediate: true
    }
  },
  computed: {
    pasteCaptureActive() {
      return this.pasteUpload && this.pasteCapture && !this.disabled;
    }
  },
  mounted() {
    this.syncPasteCaptureListener();
  },
  beforeDestroy() {
    document.removeEventListener("paste", this.onDocumentPasteCapture, true);
  },
  data() {
    return {
      stsCredentials: "",
      fileList: [],
      hoveredFile: null
    };
  },
  methods: {
    syncPasteCaptureListener() {
      document.removeEventListener("paste", this.onDocumentPasteCapture, true);
      if (this.pasteCaptureActive) {
        document.addEventListener("paste", this.onDocumentPasteCapture, true);
      }
    },

    onDocumentPasteCapture(e) {
      if (!this.pasteCaptureActive) return;
      const dt = e.clipboardData;
      if (!dt || !dt.files || !dt.files.length) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      this.addClipboardFiles(Array.from(dt.files));
    },

    onWrapperPaste(e) {
      if (!this.pasteUpload || this.disabled) return;
      if (this.pasteCaptureActive) return;
      const dt = e.clipboardData;
      if (!dt || !dt.files || !dt.files.length) return;
      e.preventDefault();
      this.addClipboardFiles(Array.from(dt.files));
    },

    async clearByIndex(index) {
      const values = this.fileList.filter((t, i) => i !== index);

      if (this.simpleData) {
        this.$emit(
          "input",
          values.map((t) => t.url)
        );
      } else {
        this.$emit("input", values);
      }
      // const client = await this.getOssClient();
      // const path = `${this.filePath}/${FileUtil.getFileName(file.url)}`;
      // client.delete(path);
    },

    normalizeRawFile(rawFile) {
      let file = rawFile;
      if (!file.name || !String(file.name).trim()) {
        const type = file.type || "";
        let ext = "";
        if (type.includes("png")) ext = ".png";
        else if (type.includes("jpeg") || type.includes("jpg")) ext = ".jpg";
        else if (type.includes("gif")) ext = ".gif";
        else if (type.includes("webp")) ext = ".webp";
        file = new File([file], `paste-${Toolkit.uuid()}${ext}`, { type: type || undefined });
      }
      if (!file.uid) {
        file.uid = Toolkit.uuid();
      }
      return file;
    },

    async uploadSingleFile(rawFile) {
      const optionFile = this.normalizeRawFile(rawFile);
      this.uploading = true;
      const client = await OssUtil.getOssClient(this.bucket);
      const dotIndex = optionFile.name.lastIndexOf(".");
      const fileType = dotIndex >= 0 ? optionFile.name.substr(dotIndex) : "";
      const fullName = `${this.filePath}/${Toolkit.uuid()}${fileType}`;

      let item = {
        name: optionFile.name,
        url: null,
        size: optionFile.size,
        status: "uploading",
        uid: optionFile.uid
      };
      this.fileList.push(item);

      try {
        const res = await client.put(fullName, optionFile);
        this.uploading = false;
        const index = this.fileList.findIndex((t) => t.uid === optionFile.uid);
        if (index >= 0) {
          this.fileList[index] = { ...item, url: res.url, status: "success" };
        }
        const values = this.simpleData ? this.fileList.map((t) => t.url) : [...this.fileList];
        this.$emit("input", values);
        if (this.onUploadSuccess) {
          this.onUploadSuccess(values);
        }
      } catch (err) {
        this.uploading = false;
        console.error(err);
        this.$message.error("上传失败");
        const failIdx = this.fileList.findIndex((t) => t.uid === optionFile.uid && t.status === "uploading");
        if (failIdx >= 0) {
          this.fileList.splice(failIdx, 1);
        }
      }
    },

    uploadHandle(option) {
      this.uploadSingleFile(option.file);
    },

    /**
     * 从剪贴板等方式追加文件（与点击上传同一套 OSS 逻辑）
     * @param {File[]} files
     */
    async addClipboardFiles(files) {
      if (this.disabled) return;
      const list = Array.from(files || []).filter((f) => f instanceof File);
      if (!list.length) return;

      const remaining = this.limit - this.fileList.length;
      if (remaining <= 0) {
        this.$message.warning(`最多上传${this.limit}个文件`);
        return;
      }
      const slice = list.slice(0, remaining);
      if (list.length > remaining) {
        this.$message.warning(`最多还可上传${remaining}个文件，已忽略多余文件`);
      }

      for (const raw of slice) {
        let ok = this.beforeUpload(raw);
        if (ok && typeof ok.then === "function") {
          try {
            ok = await ok;
          } catch {
            ok = false;
          }
        }
        if (ok === false) continue;
        await this.uploadSingleFile(raw);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.file-list {
  position: relative;
  min-height: 40px;
  padding-top: 10px;
  .file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    height: 30px;
    font-size: 13px;
    color: #606266;

    .success {
      color: rgb(103, 194, 58);
      font-size: 18px;
      cursor: pointer;
    }

    .delete {
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
